import React from 'react';
import ServicePage from '../components/ServicePage';
import { IMAGES } from '../data/mock';

export const Grooming = () => (
  <ServicePage
    title="Grooming"
    breadcrumb="Grooming"
    heroImage={IMAGES.groomingHero}
    secondaryImage={IMAGES.groomingHero2}
    intro="Professional pet grooming for a fresh and fabulous look. Pampering services designed to keep your pet looking and feeling their absolute best."
    highlights={[
      'Breed-specific cuts and styles',
      'Premium shampoos and conditioners',
      'Calm, low-stress grooming environment',
      'Nail trimming, ear cleaning and more',
    ]}
    features={[
      { title: 'Bath & Brush', text: 'Luxurious bath with breed-appropriate shampoo, blow-dry and brush out.' },
      { title: 'Full Grooming', text: 'Complete grooming including cut, style, nails, ears and finishing touches.' },
      { title: 'De-shedding', text: 'Special treatments to reduce shedding and keep coats healthy.' },
      { title: 'Nail Trim', text: 'Safe and gentle nail care to keep paws comfortable and tidy.' },
      { title: 'Ear & Eye Care', text: 'Cleaning to prevent infections and keep your pet feeling fresh.' },
      { title: 'Spa Add-ons', text: 'Paw balm, blueberry facial, teeth brushing and more pampering options.' },
    ]}
  />
);

export const Boarding = () => (
  <ServicePage
    title="Day Boarding"
    breadcrumb="Day Boarding"
    heroImage={IMAGES.boardingHero}
    secondaryImage={IMAGES.boardingHero2}
    intro="Safe and comfortable pet boarding for worry-free vacations. Your pet will enjoy a home-away-from-home filled with love, comfort, and supervised playtime."
    highlights={[
      'Spacious, clean and climate-controlled spaces',
      'Trained caretakers on site at all times',
      'Playtime, exercise and socialization',
      'Regular photo updates to pet parents',
    ]}
    features={[
      { title: 'Day Care', text: 'Drop-off and pick-up day care with full enrichment activities.' },
      { title: 'Overnight Stays', text: 'Cozy overnight boarding with bedtime routines tailored to your pet.' },
      { title: 'Play & Exercise', text: 'Regular walks, group play and enrichment to burn off energy.' },
      { title: 'Feeding Schedule', text: 'We follow your pet’s exact feeding routine and dietary needs.' },
      { title: 'Medication Care', text: 'Trained staff to administer medications as per vet instructions.' },
      { title: 'Photo Updates', text: 'Regular pictures and updates so you never miss your best friend.' },
    ]}
  />
);

export const Retail = () => (
  <ServicePage
    title="Retail Services"
    breadcrumb="Retail"
    heroImage={IMAGES.retailHero}
    intro="A premium retail shop stocked with handpicked products curated for your furry companions — from nutrition to toys, beds, treats and accessories."
    highlights={[
      'Premium pet food and treats',
      'Toys, beds and accessories',
      'Health supplements and grooming products',
      'Personalized product recommendations',
    ]}
    features={[
      { title: 'Premium Nutrition', text: 'Curated selection of top-quality foods for every breed and age.' },
      { title: 'Treats & Chews', text: 'Healthy treats, training rewards and long-lasting chews.' },
      { title: 'Toys & Enrichment', text: 'Toys that engage minds and bodies for healthier, happier pets.' },
      { title: 'Cozy Beds', text: 'Comfortable beds and crates for every size and sleeping style.' },
      { title: 'Accessories', text: 'Collars, leashes, harnesses, bowls and stylish wearables.' },
      { title: 'Grooming Products', text: 'Shampoos, brushes and care products recommended by experts.' },
    ]}
  />
);
